import { configureStore, createSlice } from '@reduxjs/toolkit'

const AUTH_KEY = 'auth_login';
const SESSION_EXPIRY_KEY = 'session_expiry';
const OTP_VERIFIED_KEY = 'otp_verified';
/** 새 창(팝업)에서 세션 복원용 - sessionStorage는 창마다 따로라 localStorage에 백업 */
const LS_SESSION_EXPIRY = 'ls_session_expiry';
const LS_OTP_VERIFIED = 'ls_otp_verified';

function getInitialLoginState() {
    if (typeof window === 'undefined') return { value: false, otpVerified: false };
    const auth = localStorage.getItem(AUTH_KEY) === 'true';
    let expiry = sessionStorage.getItem(SESSION_EXPIRY_KEY) || localStorage.getItem(LS_SESSION_EXPIRY);
    if (expiry && !sessionStorage.getItem(SESSION_EXPIRY_KEY)) {
        try { sessionStorage.setItem(SESSION_EXPIRY_KEY, expiry); } catch (e) {}
    }
    const otpStr = sessionStorage.getItem(OTP_VERIFIED_KEY) || localStorage.getItem(LS_OTP_VERIFIED);
    if (otpStr && !sessionStorage.getItem(OTP_VERIFIED_KEY)) {
        try { sessionStorage.setItem(OTP_VERIFIED_KEY, otpStr); } catch (e) {}
    }
    const now = Date.now();
    const sessionExpired = expiry && now >= Number(expiry);
    if (auth && sessionExpired) {
        try {
            localStorage.setItem(AUTH_KEY, 'false');
            sessionStorage.removeItem(SESSION_EXPIRY_KEY);
            sessionStorage.removeItem(OTP_VERIFIED_KEY);
            localStorage.removeItem(LS_SESSION_EXPIRY);
            localStorage.removeItem(LS_OTP_VERIFIED);
        } catch (e) {}
        return { value: false, otpVerified: false };
    }
    const otpOk = otpStr === 'true' && expiry && now < Number(expiry);
    return { value: auth, otpVerified: otpOk };
}

let login = createSlice({
    name: 'login',
    initialState: getInitialLoginState(),
    reducers: {
        checkLogin(state, action) {
            state.value = action.payload;
            if (!action.payload) {
                state.otpVerified = false;
                try {
                    sessionStorage.removeItem(OTP_VERIFIED_KEY);
                    sessionStorage.removeItem(SESSION_EXPIRY_KEY);
                    localStorage.removeItem(LS_OTP_VERIFIED);
                    localStorage.removeItem(LS_SESSION_EXPIRY);
                } catch (e) {}
            }
            try {
                localStorage.setItem(AUTH_KEY, action.payload ? 'true' : 'false');
            } catch (e) {}
        },
        setOtpVerified(state, action) {
            state.otpVerified = action.payload;
            try {
                if (action.payload) {
                    sessionStorage.setItem(OTP_VERIFIED_KEY, 'true');
                    localStorage.setItem(LS_OTP_VERIFIED, 'true');
                } else {
                    sessionStorage.removeItem(OTP_VERIFIED_KEY);
                    sessionStorage.removeItem(SESSION_EXPIRY_KEY);
                    localStorage.removeItem(LS_OTP_VERIFIED);
                    localStorage.removeItem(LS_SESSION_EXPIRY);
                }
            } catch (e) {}
        }
    }
})

let Darkmode = createSlice({
    name: 'Darkmode',
    initialState: { value: false },
    reducers: {
        checkMode(state, action) {
            const objString = localStorage.getItem('token');
            if (objString != null) {
                const obj = JSON.parse(objString);
                const newobj = {
                    value: obj.value,
                    expire: obj.expire,
                    mode: action.payload ? "dark" : "light",
                }
                const newobjString = JSON.stringify(newobj);
                localStorage.setItem('token', newobjString)
            }
            state.value = action.payload
        }
    }
})

let HeaderTitle = createSlice({
    name: 'HeaderTitle',
    initialState: {
        mainTitle: "",
        subTitle: ""
    },
    reducers: {
        changeHeaderTitle(state, action) {
            return action.payload
        }
    }
})

let Current_Location = createSlice({
    name: 'Current_Location',
    initialState: { value: "" },
    reducers: {
        change_Current_Location(state, action) {
            state.value = action.payload
        }
    }
})

let Favorite = createSlice({
    name: 'Favorite',
    initialState: JSON.parse(localStorage.getItem('favorite_menu')) ??
        [
            { name: "대시보드", state: 0, link: "dashboard" },
            { name: "거래내역", state: 0, link: "paylist" },
            { name: "거래보류내역", state: 0, link: "setoffPaylist" },
            { name: "정산달력", state: 0, link: "calendar" },
            { name: "가맹점 정산내역", state: 0, link: "settlements" },
            { name: "에이전트 정산내역", state: 0, link: "settlementsAgent" },
            { name: "상계내역", state: 0, link: "setoffSettlements" },
            { name: "무실적가맹점", state: 0, link: "unsoldMerchant" },
            // { name: "거래별 정산이력", state: 0, link: "payDetailList" },
            // { name: "정산이력", state: 0, link: "settlementHis" },
            // { name: "업체등록", state: 0, link: "excelData" },
            { name: "지사", state: 0, link: "distributor" },
            { name: "총판", state: 0, link: "agency" },
            { name: "대리점", state: 0, link: "franchise" },
            { name: "가맹점", state: 0, link: "submerchants" },
            { name: "관리자조회", state: 0, link: "admin" },
            // { name: "공지사항", state: 0, link: "board" },
            // { name: "단말기 관리", state: 0, link: "product" },
            { name: "즐겨찾기 관리", state: 0, link: "favorite" }
        ],
    reducers: {
        change_Favorite(state, action) {
            localStorage.setItem('favorite_menu', JSON.stringify(action.payload));
            return action.payload
        }
    }
});

let MyData = createSlice({
    name: 'MyData',
    initialState: JSON.parse(localStorage.getItem('user')) ?? [],
    reducers: {
        change_MyData(state, action) {
            const payload = action.payload;
            // 로컬스토리지에는 가맹점(Merchant) 로그인 정보만 저장
            // - type === 'merchant' 인 경우에만 name, cpId 등을 'user' 키로 보존
            // - 관리자(admin), 앱(app)는 Redux 상태만 변경하고 로컬스토리지는 건드리지 않음
            try {
                if (payload && payload.type === 'merchant') {
                    localStorage.setItem('user', JSON.stringify(payload));
                }
            } catch (e) {}
            return payload;
        }
    }
})

let total_search = createSlice({
    name: 'total_search',
    initialState: { value: "" },
    reducers: {
        change_Total_Search(state, action) {
            state.value = action.payload
        }
    }
})

let anthScreen = createSlice({
    name: 'anthScreen',
    initialState: [],
    reducers: {
        check_anthScreen(state, action) {
            return action.payload
        }
    }
})

let hostLogoImg = createSlice({
    name: 'hostLogoImg',
    initialState: { value: "fast" },
    reducers: {
        change_hostLogoImg(state, action) {
            state.value = action.payload
        }
    }
})

let pgChoose = createSlice({
    name: 'pgChoose',
    initialState: { value: "" },
    reducers: {
        change_pgChoose(state, action) {
            state.value = action.payload
        }
    }
})

let viewMode = createSlice({
    name: 'viewMode',
    initialState: { value: localStorage.getItem('viewMode') || "admin" }, // "admin" 또는 "merchant"
    reducers: {
        change_viewMode(state, action) {
            localStorage.setItem('viewMode', action.payload);
            state.value = action.payload
        }
    }
})

/** 앱 대시보드: 약국 목록 (API /api/terminal/pharmacy/with-mapping/all) */
let pharmacyList = createSlice({
    name: 'pharmacyList',
    initialState: { list: [], loaded: false },
    reducers: {
        setPharmacyList(state, action) {
            state.list = Array.isArray(action.payload) ? action.payload : [];
            state.loaded = true;
        }
    }
})

/** 관리자 공통 공급자 정보 (/api/admin/receipt-info/supplier) */
let adminSupplierInfo = createSlice({
    name: 'adminSupplierInfo',
    initialState: { info: null, loaded: false },
    reducers: {
        setAdminSupplierInfo(state, action) {
            state.info = action.payload ?? null;
            state.loaded = true;
        }
    }
})

/** 관리자 PG사(카드 가맹점) 정보 (/api/admin/receipt-info/pg-merchant) */
let adminPgMerchantInfo = createSlice({
    name: 'adminPgMerchantInfo',
    initialState: { rows: [], loaded: false },
    reducers: {
        setAdminPgMerchantInfo(state, action) {
            state.rows = Array.isArray(action.payload) ? action.payload : [];
            state.loaded = true;
        }
    }
})

/** 가맹점 공통 공급자 정보 (/api/cp/receipt-info/supplier) */
let cpSupplierInfo = createSlice({
    name: 'cpSupplierInfo',
    initialState: { info: null, loaded: false },
    reducers: {
        setCpSupplierInfo(state, action) {
            state.info = action.payload ?? null;
            state.loaded = true;
        }
    }
})

/** 가맹점 PG사(카드 가맹점) 정보 (/api/cp/receipt-info/pg-merchant) */
let cpPgMerchantInfo = createSlice({
    name: 'cpPgMerchantInfo',
    initialState: { rows: [], loaded: false },
    reducers: {
        setCpPgMerchantInfo(state, action) {
            state.rows = Array.isArray(action.payload) ? action.payload : [];
            state.loaded = true;
        }
    }
})

export let { checkLogin, setOtpVerified } = login.actions
export let { checkMode } = Darkmode.actions
export let { changeHeaderTitle } = HeaderTitle.actions
export let { change_Current_Location } = Current_Location.actions
export let { change_Favorite } = Favorite.actions
export let { change_MyData } = MyData.actions
export let { change_Total_Search } = total_search.actions
export let { check_anthScreen } = anthScreen.actions
export let { change_hostLogoImg } = hostLogoImg.actions
export let { change_pgChoose } = pgChoose.actions
export let { change_viewMode } = viewMode.actions
export let { setPharmacyList } = pharmacyList.actions
export let { setAdminSupplierInfo } = adminSupplierInfo.actions
export let { setAdminPgMerchantInfo } = adminPgMerchantInfo.actions
export let { setCpSupplierInfo } = cpSupplierInfo.actions
export let { setCpPgMerchantInfo } = cpPgMerchantInfo.actions

export default configureStore({
    reducer: {
        login: login.reducer,
        Darkmode: Darkmode.reducer,
        HeaderTitle: HeaderTitle.reducer,
        Current_Location: Current_Location.reducer,
        Favorite: Favorite.reducer,
        MyData: MyData.reducer,
        total_search: total_search.reducer,
        anthScreen: anthScreen.reducer,
        hostLogoImg: hostLogoImg.reducer,
        pgChoose: pgChoose.reducer,
        viewMode: viewMode.reducer,
        pharmacyList: pharmacyList.reducer,
        adminSupplierInfo: adminSupplierInfo.reducer,
        adminPgMerchantInfo: adminPgMerchantInfo.reducer,
        cpSupplierInfo: cpSupplierInfo.reducer,
        cpPgMerchantInfo: cpPgMerchantInfo.reducer,
    }
})
